import { PageHero } from "@/components/PageHero";
import { FAQ } from "@/data/content";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function Disclaimer() {
  return (
    <div data-testid="disclaimer-page">
      <PageHero eyebrow="Compliance" title="Disclaimer & Compliance" subtitle="KRV Prime clearly distinguishes between education and regulated financial services." crumbs={[{ label: "Disclaimer" }]} />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14 space-y-8">
        <div className="prose-sm text-slate-600 leading-relaxed space-y-5">
          <p>KRV Prime is an independent financial-market education and information platform.</p>
          <p>The website provides educational and informational material relating to financial markets, including market data, technical analysis, derivatives education, futures and options concepts, trading methodologies, market structure, historical analysis, risk management, courses, webinars, books and analytical tools.</p>
          <p>The information and material provided through this platform are intended for general educational and informational purposes. Examples, charts, strategies, scenarios, calculations and analytical observations are illustrative and do not guarantee future results.</p>
          <p>Nothing contained on KRV Prime should be construed as personalised investment advice, portfolio management, trade execution, or a guarantee of profit or financial return.</p>
          <p>Users are responsible for conducting their own research and making their own independent decisions. Financial markets, particularly futures and options, involve substantial risk and may result in loss of capital.</p>
          <p>KRV Prime does not knowingly represent itself as a bank, stock exchange, broker, financial institution, government authority or other regulated entity, and does not claim any regulatory registration, licence or authorisation that it does not hold.</p>
          <p>Educational disclaimers do not override applicable laws or regulatory requirements. Users should obtain professional advice where appropriate.</p>
          <div className="border-l-4 border-gold bg-subtle p-5 rounded-r-md">
            <p className="text-navy font-medium">KRV Prime is not, and does not claim to be:</p>
            <ul className="mt-2 list-disc pl-5 space-y-1">
              <li>A SEBI Registered Investment Adviser</li>
              <li>A SEBI Registered Research Analyst</li>
              <li>A Stockbroker or Portfolio Manager</li>
              <li>An Investment Adviser or Mutual Fund Distributor</li>
            </ul>
            <p className="mt-3 text-sm">We do not provide personalised investment recommendations. Educational certificates are not professional licences or regulatory qualifications.</p>
          </div>
        </div>

        <div>
          <h2 className="font-display text-2xl font-bold text-navy mb-4">Frequently Asked Questions</h2>
          <Accordion type="single" collapsible className="border border-border rounded-lg divide-y divide-border" data-testid="faq-accordion">
            {FAQ.map((f, i) => (
              <AccordionItem key={i} value={`f-${i}`} className="border-0">
                <AccordionTrigger className="px-5 text-left hover:no-underline text-navy font-medium">{f.q}</AccordionTrigger>
                <AccordionContent className="px-5 text-slate-600">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </div>
  );
}
